var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import getFetchWrapper from 'syf-api/api/getFetchWrapper';
import ENDPOINTS from '../../../const/endpoints';
var mutationFnFactory = function (config, hasNewAuthorizedUser, keyProps) {
    var fetchWrapper = getFetchWrapper(config);
    var isScopeCheckNeeded = !hasNewAuthorizedUser && {
        'X-SYF-Expect': '100-continue'
    };
    return function (_a) {
        var authorizedUsers = _a.authorizedUsers;
        var requestPayload = {
            'cipher.accountId': keyProps.accountId,
            accountIdType: keyProps.accountIdType,
            authorizedUsers: authorizedUsers
        };
        return fetchWrapper(ENDPOINTS.authorizedUsers, {
            method: 'POST',
            body: JSON.stringify(requestPayload),
            headers: __assign({}, isScopeCheckNeeded)
        });
    };
};
export default mutationFnFactory;
